import {
	customBreakpoints,
	customTransitions,
	customContainers,
	customGridLayout,
	customZIndex,
} from '@/css/variables.css';

/**
 * FONTS
 */
export const fontFamilies = {
	primary: 'Knockout, sans-serif',
	secondary: 'Gotham SSm, sans-serif',
	tertiary: 'Fresco, serif',
};

/* Font weights */
export const fontWeights = {
	thin: 100,
	extralight: 200,
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 600,
	bold: 700,
	extrabold: 800,
	black: 900,
};

export const colors = {
	brand1Base: '#c6e6d7',
	brand1Lighter: '#000000',
	brand1Darker: '#6dbe9a',
	brand2Base: '#ffe772',
	brand2Lighter: '#000000',
	brand2Darker: '#f9df5f',
	text: '#000000',
	neutral000: '#ffffff',
	neutral100: '#f3f4f6',
	neutral200: '#ededec',
	neutral300: '#D1D5DB',
	neutral400: '#9CA3AF',
	neutral500: '#6B7280',
	neutral600: '#4B5563',
	neutral700: '#374151',
	neutral800: '#1c1c1c',
	neutral900: '#000000',
	highlight: '#cfff9b',
	warning: '#a5181a',
	presse: '#f5f5f0',
	brandTertiaryBase: '#ffcc89',
	brandTertiaryDarker: '#fac075',
	brandQuaternaryBase: '#ffabd1',
	brandQuaternaryDarker: '#dbacd0',
	available: '#54c061',
};

/**
 * FLUID SIZING BREAKPOINTS
 *
 * This defines at which size the fluid-sizing mechanism
 * should start, and end.
 */
export const breakpoints = customBreakpoints ?? {
	fluidMin: '375px',
	fluidMax: '1680px',
	fluidHuge: '2560px',
	mobile: '480px',
	small: '600px',
	tablet: '768px',
	medium: '900px',
	laptop: '1024px',
	bigLaptop: '1200px',
	desktop: '1440px',
	bigDesktop: '1920px',
	huge: '2560px',
};

/**
 * TRANSITIONS
 *
 * Define standard transition timings.
 */
export const transitions = customTransitions ?? {
	fast: '0.15s',
	mid: '0.3s',
	slow: '0.5s',
};

/**
 * GRID
 */
/* container */
export const containers = customContainers ?? {
	minOffset: '24px',
	tabletOffset: '40px',
	laptopOffset: '56px',
	desktopOffset: '72px',
	maxWidth: '1300px',
	maxWidthMq:
		'1444px' /* when the grid reaches its max width: maxWidth + desktopOffset * 2 */,
};

/*
 * GRID LAYOUT
 */
export const gridLayout = customGridLayout ?? {
	gap: '2.13vw',
	gapMax: '32px',
	gapMaxMq: '1500px' /* approx. when grid-gap reaches grid-gap-max */,
};

/**
 * Z-INDEXES
 */
export const zIndex = customZIndex ?? {
	page: 10,
	gdprBanner: 14,
	gdprModal: 15,
	modal: 20,
};
